<template>
  <section>
    <div
      class="is-flex is-align-items-center py-5 mt-5 is-clickable"
      :class="{ 'selected-doc-tree': actualSelected }"
      @click="toggle"
      @click.once="checkAndGetItens"
    >
      <span class="is-flex">
        <b-icon class="pl-10 pr-15" size="is-small" :icon="iconBox" />
      </span>
      <b class="is-unselectable pr-15">{{ groupName.toUpperCase() }}</b>
    </div>
    <div v-if="expanded" class="pl-25">
      <template v-if="!docList.length">
        <div
          v-for="index in 4"
          :key="`doc_skeleton_${index}`"
          class="is-flex mb-5"
        >
          <span class="icon is-small mr-10">
            <b-skeleton />
          </span>
          <b-skeleton width="80%" animated />
        </div>
      </template>
      <DocTree
        v-for="item in docList"
        :key="item.id"
        v-model="selectDoc"
        :docName="`${item.position}. ${item.name}`"
        :docId="item.id"
      />
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import DocTree from "@/views/Process/DocTree";

export default {
  name: "DocCollapseTree",
  components: {
    DocTree
  },
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    groupName: {
      type: String,
      default: () => ""
    },
    value: {
      type: String,
      default: () => ""
    },
    openByDefault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: false,
      docList: [],
      startAt: 0
    };
  },
  computed: {
    actualSelected() {
      return [this.groupName, ...this.docList.map(item => item.id)].includes(
        this.value
      );
    },
    selectDoc: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update", value);
      }
    },
    iconBox() {
      return this.actualSelected || this.expanded
        ? "minus-box-outline"
        : "plus-box-outline";
    },
    processId() {
      return this.$route.params.id;
    },
    giveKnowledgeId() {
      return this.$route.query.give_knowledge_id;
    }
  },
  async beforeMount() {
    if (this.openByDefault) {
      const resp = await this.checkAndGetItens();
      if (resp) this.expanded = true;
    }
  },
  methods: {
    ...mapActions(["getGroupItens"]),
    toggle() {
      this.expanded = !this.expanded;
    },
    mountDoc(doc, index) {
      return {
        id: doc.id,
        name: doc.attachment_name,
        position: this.startAt + index
      };
    },
    async checkAndGetItens() {
      if (this.docList.length === 0) {
        const { type, id } = this.$attrs;
        const result = await this.getGroupItens({
          type,
          id,
          process_id: this.processId,
          give_knowledge_id: this.giveKnowledgeId
        });
        if (result?.files) {
          this.startAt = result.start_at;
          this.docList = result.files.map(this.mountDoc);
          return true;
        }
      }
    }
  }
};
</script>
